import React, { memo } from 'react';
import { Dropdown } from 'react-bootstrap';
import Tippy from '@tippyjs/react';

import notificationIcon from '../assets/img/notification.svg';
import bellIcon2 from '../assets/img/bell-01.svg';
import msgIcon from '../assets/img/msg-icon.svg';
import khanbanIcon2 from '../assets/img/khanban-icon.svg';
import calenderIcon2 from '../assets/img/calendar-date.svg';
import rightArrowdown from '../assets/img/right-arrow-down.svg';

import { getPackClass, hasPermission, selectLoader } from '../utils/Helpers';

const HomeHeaderContent = ({
  isProjectsAvailable,
  subInfo,
  isUser1,
  userRole,
  isOwner,
  user,
  totalProjects,
  statusCounts,
  isUnread,
  isUpdatingPlan,
  userShortName,
  onStatusClick,
  onProfileClick,
  onNotificationClick,
  onKanbanClick
}) => {
  const canViewProjects =
    isProjectsAvailable &&
    ((subInfo?.isActive && isUser1) || !isUser1);

  const canManageProjects =
    isUser1 &&
    subInfo?.isActive &&
    hasPermission(userRole, 'update_projects');

  const canShowSubscribe =
    hasPermission(userRole, 'plan_details') &&
    isOwner &&
    user &&
    !subInfo?.isActive;

  return (
    <>
      {canViewProjects && (
        <div className="btn-group-head">
          <Tippy content="Total Projects" placement="top" arrow>
            <button className="btn-black">
              <span>
                {totalProjects < 10 && 0}
                {totalProjects}
              </span>
              Project{totalProjects > 1 && 's'}
            </button>
          </Tippy>

          <button className="btn-black project-btn-list">
            <Tippy content="Early" placement="top" arrow>
              <span
                className="light-blue-bg"
                onClick={() => onStatusClick('early')}>
                {statusCounts?.early < 10 && 0}
                {statusCounts?.early || 0}
              </span>
            </Tippy>

            <Tippy content="On-time" placement="top" arrow>
              <span
                className="light-green-bg"
                onClick={() => onStatusClick('ontime')}>
                {statusCounts?.ontime < 10 && 0}
                {statusCounts?.ontime || 0}
              </span>
            </Tippy>

            <Tippy content="Late" placement="top" arrow>
              <span
                className="light-red-bg"
                onClick={() => onStatusClick('late')}>
                {statusCounts?.late < 10 && 0}
                {statusCounts?.late || 0}
              </span>
            </Tippy>
          </button>
        </div>
      )}

      <div className="head-right">
        {canShowSubscribe && (
          <button
            className={getPackClass(
              subInfo?.status,
              subInfo?.isActive
            )}>
            {isUpdatingPlan ? (
              <span className="plan-updating">
                Updating {selectLoader(25)}
              </span>
            ) : (
              'Subscribe'
            )}
          </button>
        )}

        {canManageProjects && (
          <>
            <Tippy
              content="Happy Clients"
              placement="top"
              arrow>
              <img
                src={msgIcon}
                alt="clients"
                className="nsg-img active_img"
              />
            </Tippy>

            <div onClick={() => onKanbanClick(false)}>
              <Tippy
                content="Happy Projects"
                placement="top"
                arrow>
                <img
                  src={khanbanIcon2}
                  alt="kanban"
                  style={{ cursor: 'pointer' }}
                />
              </Tippy>
            </div>

            <div onClick={() => onKanbanClick(true)}>
              <Tippy
                content="My Calendar"
                placement="top"
                arrow>
                <img
                  src={calenderIcon2}
                  alt="calendar"
                  className="feather-img2 menuicon cursor_pointer"
                />
              </Tippy>
            </div>
          </>
        )}

        {canViewProjects && (
          <Dropdown className="notify-drp">
            <Dropdown.Toggle
              as="a"
              className="dropdown-toggle"
              onClick={onNotificationClick}>
              <Tippy
                content="Notifications"
                placement="top"
                arrow>
                {isUnread ? (
                  <img
                    src={notificationIcon}
                    alt="notification"
                    className="notification-img"
                  />
                ) : (
                  <img
                    src={bellIcon2}
                    alt="notification"
                    className="bellIcon-img2"
                  />
                )}
              </Tippy>
            </Dropdown.Toggle>
          </Dropdown>
        )}

        <a
          className="menuicon-user"
          onClick={onProfileClick}>
          {userShortName}
          <img
            src={rightArrowdown}
            alt="menu"
            className="menuicon2"
          />
        </a>
      </div>
    </>
  );
};

export default HomeHeaderContent;